export default "__VITE_ASSET__bd41f8f3__"